angular.module('lf.common')

.directive('mustMatch', function ($timeout) {
  return {
    require: 'ngModel',
    scope: {
      mustMatch: '=',
    },
    link: function (scope, el, attrs, model) {
      var validator = function (val) {
        var valid = (angular.isUndefined(scope.mustMatch) || scope.mustMatch === val);
        model.$setValidity('mustMatch', valid);
        return val;
      }
      model.$parsers.push(validator);
      model.$formatters.push(validator);
    }
  }
});
